var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71429 11.4286H12.5714V14.8571H2.28571V2.28571C2.28571 1.024 3.30971 0 4.57143 0H22.8571C24.12 0 25.1429 1.024 25.1429 2.28571V3.42857H5.71429V11.4286ZM0 17.1429H12.5714V18.2857C12.5714 19.1223 12.8137 19.896 13.208 20.5714H2.28457C1.02286 20.5714 0 19.5486 0 18.2869V17.1429ZM25.1429 5.71429H17.1429C15.8857 5.71429 14.8571 6.74286 14.8571 8V18.2857C14.8571 19.5429 15.8857 20.5714 17.1429 20.5714H25.1429C26.4 20.5714 27.4286 19.5429 27.4286 18.2857V8C27.4286 6.74286 26.4 5.71429 25.1429 5.71429ZM18.2857 17.1429H24V9.14286H18.2857V17.1429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/Shape.ad5f013f75bdd343d60a18e97d702c7a.svg";
export { ForwardRef as ReactComponent };